import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../context/authStore';
import confetti from 'canvas-confetti';
import toast from 'react-hot-toast';
import './CampaignBanner.css';

export default function CampaignBanner({ campaign }) {
  const navigate = useNavigate();
  const { user, userDoc } = useAuthStore();
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  function calculateTimeLeft() {
    const difference = +new Date(campaign.endDate) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
  });

  if (!campaign) return null;

  const hasTimeLeft = Object.keys(timeLeft).length > 0;

  const handleClaim = () => {
    if (!user) {
      toast.error('يجب تسجيل الدخول كطالب أولاً لتفعيل العرض');
      return navigate('/login');
    }
    if (userDoc?.role !== 'student') {
      return toast.error('هذا العرض مخصص للطلاب فقط');
    }

    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.8 },
      colors: ['#f59e0b', '#fff']
    });
    toast.success('تم تفعيل العرض! تصفح الكورسات الآن');
    setTimeout(() => {
      navigate('/courses');
    }, 1000);
  };

  return (
    <div
      className="pro-campaign-banner"
      style={campaign.bannerImage ? { backgroundImage: `url(${campaign.bannerImage})`, backgroundSize: 'cover', backgroundPosition: 'center' } : {}}
    >
      {campaign.bannerImage && <div className="pcb-overlay" />}
      <div className="pcb-content">
        <div className="pcb-info">
          <span className="pcb-badge">
            {timeLeft.days === 0 && timeLeft.hours < 12 ? 'ينتهي قريباً جداً! ⌛' : 'عرض خاص لفترة محدودة 🔥'}
          </span>
          <h3 className="pcb-title">{campaign.title}</h3>
          <p className="pcb-desc">{campaign.description || 'خصومات حصرية لفترة محدودة!'}</p>
          <div className="pcb-progress-wrap">
            <div className="pcb-progress-bar">
              <div className="pcb-progress-fill" style={{ width: '85%' }} />
            </div>
            <span className="pcb-progress-text">تم حجز 85% من المقاعد المخصصة لهذا العرض!</span>
          </div>
        </div>

        {hasTimeLeft && (
          <div className="pcb-countdown">
            <div className="pcb-time-item">
              <span className="pcb-time-val">{timeLeft.days}</span>
              <span className="pcb-time-lbl">يوم</span>
            </div>
            <div className="pcb-time-item">
              <span className="pcb-time-val">{timeLeft.hours}</span>
              <span className="pcb-time-lbl">ساعة</span>
            </div>
            <div className="pcb-time-item">
              <span className="pcb-time-val">{timeLeft.minutes}</span>
              <span className="pcb-time-lbl">دقيقة</span>
            </div>
            <div className="pcb-time-item">
              <span className="pcb-time-val">{timeLeft.seconds}</span>
              <span className="pcb-time-lbl">ثانية</span>
            </div>
          </div>
        )}

        <div className="pcb-action">
          <button className="pcb-claim-btn" onClick={handleClaim}>احصل على العرض ✨</button>
          <div className="pcb-discount">
            <div className="pcb-disc-val">
              {campaign.discountType === 'percentage' ? `${campaign.discountValue}%` : `${campaign.discountValue} ج.م`}
            </div>
            <div className="pcb-disc-lbl">خصم</div>
          </div>
        </div>
      </div>
    </div>
  );
}
